import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SubscriptionData {
    customerId: string;
    subscriptions: any[];
    customerSessionSecret?: string;
}

export interface SubscriptionState {
    data: SubscriptionData | null;
    loading: boolean;
    error: string | null;
    lastFetched: number | null;
    showPlans: boolean;
}

const initialState: SubscriptionState = {
    data: null,
    loading: false,
    error: null,
    lastFetched: null,
    showPlans: false,
};

const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setSubscriptionData: (state, action: PayloadAction<SubscriptionData | null>) => {
            state.data = action.payload;
            state.lastFetched = Date.now();
            state.error = null;
            // Automatically determine if we should show plans
            state.showPlans = !action.payload || !hasActiveSubscription(action.payload);
        },
        setError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
        },
        clearError: (state) => {
            state.error = null;
        },
        setShowPlans: (state, action: PayloadAction<boolean>) => {
            state.showPlans = action.payload;
        },
        clearSubscriptionData: (state) => {
            state.data = null;
            state.lastFetched = null;
            state.error = null;
            state.showPlans = true;
        },
    },
});

// Helper function to check if user has active subscription
const hasActiveSubscription = (data: SubscriptionData | null): boolean => {
    if (!data || !data.subscriptions) return false;
    return data.subscriptions.some(sub => 
        sub.status === 'active' || sub.status === 'trialing'
    );
};

export const {
    setLoading,
    setSubscriptionData,
    setError,
    clearError,
    setShowPlans,
    clearSubscriptionData,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer; 